import api from './api';

const projectsUrl = '/api/v1/projects';

export default {
  count: async (filter: any): Promise<any> =>
    api.post(`${projectsUrl}/count`, filter),
  delete: async (id: string): Promise<any> =>
    api.delete(`${projectsUrl}/${id}`),
  get: async (id: string): Promise<any> => api.get(`${projectsUrl}/${id}`),
  getAll: async (filter: any): Promise<any> =>
    api.post(`${projectsUrl}/filter`, filter),
  itemsExcel: {
    get: async (
      id: string,
      type: string,
      ids: string[],
      translations: {
        translations: { [key: string]: string };
        section: string;
      }[],
      glassesSeNumbers: string[]
    ): Promise<any> =>
      api.getFileByPost(`${projectsUrl}/${id}/itemsexcel`, {
        type,
        ids,
        translations,
        glassesSeNumbers,
      }),
  },
  post: async (data?: any): Promise<any> => api.post(`${projectsUrl}`, data),
  put: async (id: string, data: any): Promise<any> =>
    api.put(`${projectsUrl}/${id}`, data),
};
